import { ShopifyEditor } from './editor'

const { Shopify }: any = window

export class BaseComponent extends HTMLElement {
  listeners: { element: any; event: any; listener: any }[] = []
  events: object = {}
  editor: ShopifyEditor = new ShopifyEditor()
  isEditor: boolean = Shopify.designMode

  connectedCallback() {
    try {
      this.mountComponent()
    } catch (error) {
      console.log(this.tagName, 'mount', error.name)
      console.log(error)
    }
  }

  disconnectedCallback() {
    try {
      this.unmountComponent()
    } catch (error) {
      console.log(this.tagName, 'unmount', error.name)
    }

    if (this.isEditor) {
      this.editor.destroy()
    }

    this.destroyListeners()
  }

  mountComponent() {}

  unmountComponent() {}

  on(event: string, listener: any): void {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(listener)
  }

  off(event: string, removedListener: any): void {
    if (!this.events[event]) {
      return
    }
    this.events[event] = this.events[event].filter(
      listener => listener !== removedListener,
    )
  }

  emit(event: string, data: any): void {
    if (!this.events[event]) {
      return
    }
    this.events[event].forEach(listener => listener(data))
  }

  addListener(
    element: any,
    event: string,
    listener: any,
    options?: object,
  ): void {
    if (!element || !event || !listener) {
      return
    }
    element.addEventListener(event, listener, options)
    this.listeners = [...this.listeners, { element, event, listener }]
  }

  removeListener(
    targetElement: any,
    targetEvent: string,
    targetListener: any,
  ): void {
    if (!targetElement || !targetEvent || !targetListener) {
      return
    }
    targetElement.removeEventListener(targetEvent, targetListener)
    this.listeners = this.listeners.filter(({ element, event, listener }) => {
      return (
        element !== targetElement &&
        event !== targetEvent &&
        listener !== targetListener
      )
    })
  }

  destroyListeners(): void {
    this.listeners.forEach(({ element, event, listener }) => {
      element.removeEventListener(event, listener)
    })
    this.listeners = []
  }
}
